import { Component, computed, input } from '@angular/core';
import { DotPulseComponent } from '../../../../../../../../../../../../shared/components/dot-pulse/dot-pulse.component';
import { SparePartsVariant, getDaysElapsed } from '../../../../repair-tracker-timeline.utils';

@Component({
  selector: 'app-waiting-for-parts',
  imports: [DotPulseComponent],
  templateUrl: './waiting-for-parts.component.html',
  styleUrl: './waiting-for-parts.component.scss',
})
export class WaitingForPartsComponent {
  statusChange = input<string | undefined>(undefined);

  protected viewModel = computed(() => {
    const variant = this.getVariant(this.statusChange());
    const colourVariant: 'success' | 'warning' = variant === 'delayed' ? 'warning' : 'success';
    return {
      message: this.getMessage(variant),
      colourVariant,
    };
  });

  private getVariant(statusChange: string | undefined): SparePartsVariant {
    const days = getDaysElapsed(statusChange);
    if (days >= 5) return 'delayed';
    if (days >= 3) return 'in-transit';
    return 'initial';
  }

  private getMessage(variant: SparePartsVariant): string {
    const messages: Record<SparePartsVariant, string> = {
      initial: "We've ordered your parts and will let you know as soon as they arrive.",
      'in-transit': "Your parts are on their way. We'll let you know as soon as they arrive.",
      delayed:
        "Your parts haven't arrived yet, but we're working to sort this out quickly for you. Thanks for your patience.",
    };
    return messages[variant];
  }

  get vm() {
    return this.viewModel();
  }
}
